// extracted by mini-css-extract-plugin
export default {"containerWord":"WordView_containerWord__4Wqm8","modelContainer":"WordView_modelContainer__zL-XY"};